module.exports = __webpack_public_path__ + "media/images/help/fields_result-8ba0ab92191fc19a7feb9ed1ea7923e9.png";